<template>
  <b-container v-if="group" fluid class="p-3">
    <b-row>
      <b-col>
        <b-card no-body>
          <h6 slot="header" class="mb-0">
            <font-awesome-icon icon="plus-circle" />แก้ไขหน่วยงาน
          </h6>
          <table class="table mb-0">
            <tbody>
              <tr v-if="group.parent">
                <td>
                  <strong>สังกัด</strong>
                </td>
                <td class="align-middle">
                  <b-select v-model="group.parent._id" :options="parentOptions" />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>ประเภท</strong>
                </td>
                <td class="align-middle">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="group.type"
                    :options="options"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>ชื่อหน่วยงาน</strong>
                </td>
                <td class="align-middle">
                  <b-form-input v-model="group.name" />
                </td>
              </tr>
              <tr v-if="group.type !== 'Council' && group.type !== 'StudentUnion'">
                <td>
                  <strong>เปิดใช้งาน</strong>
                </td>
                <td class="align-middle">
                  <b-form-radio-group
                    id="radio-group-2"
                    v-model="group.isEnabled"
                    :options="isEnabledOptions"
                  />
                  <b-alert
                    :show="!group.isEnabled"
                    variant="danger"
                    class="my-2"
                  >
                    กรุณาตรวจสอบให้แน่ใจว่าหน่วยงานนี้<strong><u>ไม่มีโครงการที่ยังไม่เสร็จสิ้นค้างอยู่</u></strong><br>
                    เนื่องจากการปิดหน่วยงานจะทำให้บุคคลที่เกี่ยวข้องในหน่วยงานทั้งหมดไม่สามารถสลับไปใช้สิทธิ์ที่เกี่ยวกับหน่วยงานนี้ได้อีก
                  </b-alert>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card class="mt-3">
          <b-button variant="primary" @click="submit">
            <font-awesome-icon icon="save" /> บันทึก
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import gql from 'graphql-tag'

import groupFetchApplicableParentListQuery from '@/graphql/queries/fetchApplicableParentList.gql'

export default {
  apollo: {
    group: {
      query: gql`query GetGroup($id: ID!) { group(id: $id) { id, name, type, department, chiefName, parent, isEnabled } }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      group: {
        type: null,
        isEnabled: null
      },
      options: [
        { text: 'สโมสร', value: 'Association' },
        { text: 'ชมรม', value: 'Club' },
        { text: 'ชุมนุม', value: 'Group' },
        { text: 'สโมสรนักศึกษา', value: 'StudentCouncil' },
        { text: 'องค์การนักศึกษา', value: 'StudentUnion' },
        { text: 'กลุ่ม', value: 'PeopleGroup' },
        { text: 'สภา', value: 'Council' }
      ],
      isEnabledOptions: [
        { text: 'เปิด', value: true },
        { text: 'ปิด', value: false }
      ],
      parentOptions: []
    }
  },
  computed: {
    parentApplicable () {
      return this.group.type === 'StudentCouncil' || this.group.type === 'Group'
    },
    parentType () {
      if (this.group.type === 'StudentCouncil') { return 'StudentCouncil' }
      if (this.group.type === 'Group') { return 'Group' }
      return null
    }
  },
  watch: {
    parentType (type) {
      this.group.parentId = null
      if (type === null) { return }
      this.fetchParentList(type)
    }
  },
  methods: {
    async submit () {
      const payload = {
        name: this.group.name,
        isEnabled: this.group.isEnabled
      }

      if (this.group.parent && this.group.parent._id) {
        payload.parentId = this.group.parent._id
      }

      let group = await this.$apollo.mutate({
        mutation: gql`mutation ($input: GroupEditInput) { groupEdit(input: $input) { id } }`,
        variables: {
          input: {
            id: this.group.id,
            patch: payload
          }
        }
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })
      this.$router.push({ name: 'settings.groups.show', params: { id: group.data.groupEdit.id } })
    },
    async fetchParentList (type) {
      const result = await this.$apollo.query({
        query: groupFetchApplicableParentListQuery,
        variables: { type }
      })

      this.parentOptions = result.data.groupFetchApplicableParentList
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
